import React, { FC } from 'react';
import { ModalManager, ModalRouteProps } from 'context/ModalRouter';
import { useInvalidatePostsQueries } from 'app/modules/posts/hooks/useInvalidatePostsQueries';
import { useQuery } from 'react-query';
import { queryKey } from 'constants/queryKey';
import PostApi from 'api/post';
import MovePostsModal from 'app/modules/posts/modules/movePosts/components/MovePostsModal';

type Props = ModalRouteProps;

const MovePosts: FC<Props> = (props) => {
  const invalidatePostsQueries = useInvalidatePostsQueries();

  const modalManager: ModalManager = {
    ...props.modalManager,
    close: () => {
      props.modalManager.close();
      invalidatePostsQueries();
    },
  };

  const postId = parseInt(props.modalManager.getQueryParameter('posts'));
  const { data, isLoading } = useQuery(queryKey.postDetail(postId), () =>
    PostApi.detail(postId),
  );

  return (
    <MovePostsModal
      modalHistory={props.modalHistory}
      modalManager={modalManager}
      initialPosts={data ? [data] : []}
      isLoading={isLoading}
    />
  );
};

export default MovePosts;
